// src/components/PinExtensionModal.js
// Shown top-right on whatever page the user lands on after installing the
// extension (?pin=1), pointing at Chrome's toolbar. An unpinned extension is an
// extension the user cannot find again.
import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../styles/components/StatePage.css';

const DISMISS_KEY = 'michii_pin_prompt_done';

const PinExtensionModal = () => {
  const [params] = useSearchParams();
  // The dismiss flag, not the URL param, is what stops this coming back — so a
  // reload (or a URL someone pasted to a friend) shows it at most once.
  const [open, setOpen] = useState(
    () => params.get('pin') === '1' && !localStorage.getItem(DISMISS_KEY)
  );

  if (!open) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setOpen(false);
  };

  return (
    <div className="pin-prompt" role="dialog" aria-label="Pin the Michii extension">
      <p className="pin-prompt__eyebrow"><span>One last step</span><span>Chrome toolbar ↑</span></p>

      {/* A stand-in for Chrome's toolbar and Extensions menu, with the two
          things to click ringed the way Michii rings a step. */}
      <div className="pin-prompt__toolbar" aria-hidden="true">
        <i /><i />
        <span className="pin-prompt__icon">
          <span className="pin-prompt__num">1</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"><path d="M10 3h4v3a2 2 0 1 0 4 0V3h3v7h-3a2 2 0 1 0 0 4h3v7h-7v-3a2 2 0 1 0-4 0v3H3v-7h3a2 2 0 1 0 0-4H3V3h7z" /></svg>
        </span>
      </div>
      <div className="pin-prompt__menu" aria-hidden="true">
        <span>Michii</span>
        <span className="pin-prompt__icon">
          <span className="pin-prompt__num">2</span>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 17v5" /><path d="M9 3h6l-1 7 4 3v2H6v-2l4-3z" /></svg>
        </span>
      </div>

      <h3>Pin Michii for easy access</h3>
      <p>
        Click the puzzle-piece icon in Chrome's toolbar, then the pin next to Michii.
        Record and play guides from any tab.
      </p>

      <button onClick={dismiss} className="pin-prompt__btn">
        Got it
      </button>
    </div>
  );
};

export default PinExtensionModal;
